// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSLabelValueList/ABSLabelValue.less
// module id = 783
// module chunks = 42